export default {"src":"/_next/static/media/icon_04.3124e2bb.svg","height":30,"width":29};